import {Axios} from '../axios/axios.js'
//获取司机播放设置
export const getDriverBroadList = (e) => {
  return Axios({
    url:"/index.php/worker/get_worker_broadcast_list",
    method:'put',
    data:e
  })
}
//获取播放设置
export const getBroadcastList = (e) => {
  return Axios({
    url:"/index.php/worker/get_broadcast_set",
    method:'put',
    data:e
  })
}
//修改播放设置
export const changeBroadcastList = (e) => {
  return Axios({
    url:"/index.php/worker/change_broadcast_set",
    method:'put',
    data:e
  })
}
//修改司机播放设置
export const changeBroadcastDriver = (e) => {
  return Axios({
    url:"/index.php/worker/edit_worker_broadcast",
    method:'put',
    data:e
  })
}
//刷新司机列表
export const refreshDriverList = (e) => {
  return Axios({
    url:"/index.php/worker/refresh_work",
    method:'put',
    data:e
  })
}
